import { testimonials } from "@/mocks/testimonials";

export default function VoiceSection() {
  return (
    <section id="voice" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="eyebrow">
              <i className="ri-chat-quote-line" aria-hidden="true"></i>
              用户口碑
            </p>
            <h2 className="section-title mt-4">长期围观的人怎么说</h2>
          </div>
          <div className="flex items-center gap-3 rounded-lg border border-accent-200 bg-accent-50 px-4 py-3">
            <i className="ri-emotion-happy-line text-xl text-accent-700" aria-hidden="true"></i>
            <p className="font-body text-sm text-accent-900">
              <strong className="font-bold">96%</strong> 的读者表示，看档案比刷片段更省时间
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-primary-300" aria-hidden="true"></i>
              <blockquote className="mt-3 flex-1 font-body text-sm leading-relaxed text-foreground-700">
                {item.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                  {item.initial}
                </span>
                <span className="flex flex-col">
                  <strong className="font-label text-sm font-medium text-foreground-950">{item.name}</strong>
                  <span className="font-label text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}